<script setup>
defineProps({
  fieldModel: Object,
  disabled: Boolean
})
</script>

<template>
  <select
    v-model="fieldModel.inputValue"
    :disabled="disabled || !fieldModel.editable"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
  >
    <slot/>
  </select>
</template>
